import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../Core/Context/AuthContext';
import { callApi } from '../../../Utils/Api/Api';
import { Loader } from '@progress/kendo-react-indicators';
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from '../../Core/Components/shadcn/card';

const SocialLoginRedirect = () => {
  const navigate = useNavigate();
  const { checkTokens, completeLogin } = useAuth();
  const [message, setMessage] = useState('Redirecting...');
  const [authenticating, setAuthenticating] = useState(true);

  useEffect(() => {
    const query = new URLSearchParams(window.location.search);

    // Check if auth code and driver are present in query params
    const authCode = query.get('code');
    const driver = query.get('state');
    if (authCode && driver) {
      verifyAuthCode(authCode, driver);
    } else if (checkTokens()) {
      window.location.replace('/');
    } else {
      navigate('/login');
    }
  }, [navigate, checkTokens]);

  const verifyAuthCode = async (code, driver) => {
    try {
      const payload = { code, driver };
      if (driver === 'openid') {
        const verifier = sessionStorage.getItem('OIDC_CODE_VERIFIER');
        if (verifier) {
          payload.code_verifier = verifier;
        }
      }
      const response = await callApi('/social/auth/Code', 'POST', payload);
      if (response?.isSuccess) {
        const data = response.payload;
        if (driver === 'openid') {
          sessionStorage.removeItem('OIDC_CODE_VERIFIER');
        }
        completeLogin(data);
        window.location.replace('/');
      } else {
        handleAuthenticationError('Failed to authenticate.');
      }
    } catch (error) {
      handleAuthenticationError('Authentication failed. Please try again.');
    }
  };

  const handleAuthenticationError = (errorMessage) => {
    setMessage(errorMessage);
    setAuthenticating(false);
    setTimeout(() => navigate('/login'), 3000);
  };
  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-4">
      <Card className="w-full max-w-md">
        <CardHeader className="border-b border-border/60">
          <CardTitle className="text-[20px] font-semibold text-foreground">
            Authentication Status
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-4 py-5 text-center">
          <div className="text-[18px] font-medium text-foreground">{message}</div>

          {authenticating ? (
            <>
              <div className="text-[13px] leading-6 text-muted-foreground">
                Please wait while we complete your authentication.
              </div>
              <div className="flex justify-center">
                <Loader size="medium" type="pulsing" themeColor="info" />
              </div>
            </>
          ) : (
            <div className="text-[13px] leading-6 text-muted-foreground">
              Redirecting...
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default SocialLoginRedirect;
